import React, { useState } from "react";
import { Menu } from "@mui/icons-material";
import "./css/header.css";
import { Link } from "react-router-dom";

export const Header = () => {
  const [response, setResponse] = useState(false);

  return (
    <>
      <header>
        <div className="container flexsb">
          <div className={response ? "navHide" : "nav"}>
            <Link to="/" onClick={() => setResponse(false)}>Home</Link>
            <Link to="/about" onClick={() => setResponse(false)}>About</Link>
            <Link to="/contact" onClick={() => setResponse(false)}>Contact</Link>
            <Link to="/service" onClick={() => setResponse(false)}>Service</Link>
            <Link to="/portfolio" onClick={() => setResponse(false)}>Portfolio</Link>
            <Link to="/skill" onClick={() => setResponse(false)}>Skill</Link>
          </div>

          <div className="icon">
            <button className="toggle" onClick={() => setResponse(!response)}>
              <Menu className="icon" />
            </button>
          </div>
        </div>
      </header>
    </>
  );
};
